import {
  GroupMultiSelect,
  InternalOption,
} from 'components/UIComponents/GroupMultiSelect';
import { Group } from 'components/UIComponents/GroupMultiSelect/GroupMultiSelect.types';
import { useCallback, useMemo } from 'react';

import { SectionType } from 'pages/ClaimsContractsToolPage/types';
import { UserInfo } from '../../api/endpoints';
import {
  assignedGroupUsersToSelectGroups,
  ReviewersGroupChecked,
  selectOptionsToBatchItem,
} from './ReviewersEdit.utils';
import { ReviewersEditLabel } from './ReviewersEditLabel';

export interface ClaimReviewersValues {
  claimReviewerUserGroupIds: number[];
  claimReviewerUserIds: number[];
}

export interface ContractReviewersValues {
  contractReviewerUserGroupIds: number[];
  contractReviewerUserIds: number[];
}

export type ReviewersEditProps = {
  users: UserInfo[];
  groups: ReviewersGroupChecked[];
  loading: boolean;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  onChange: (item: any) => void;
  section: SectionType | undefined;
};

export const ReviewersEdit = ({
  users = [],
  groups = [],
  loading,
  disabled,
  label,
  placeholder,
  onChange,
  section,
}: ReviewersEditProps) => {
  const selectGroups: Group[] = useMemo(
    () => (!loading ? assignedGroupUsersToSelectGroups(groups, users) : []),
    [users, groups, loading],
  );
  const handleSubmit = useCallback(
    (selected: InternalOption[]) => {
      const batchItem = selectOptionsToBatchItem(selected, section);
      onChange(batchItem);
    },
    [onChange, section],
  );

  return (
    <GroupMultiSelect
      loading={loading}
      label={label}
      groups={selectGroups}
      hasSearch
      mainLabelComponent={ReviewersEditLabel}
      disabled={loading || disabled}
      onSubmit={handleSubmit}
      placeholder={placeholder}
    />
  );
};
